<template>
	<modal
		size="medium"
		@close="close">
		<template slot="header">
			<h3>
				<i class="material-icons">local_shipping</i>
				<span>{{ $t('Product Shipping') }}</span>
			</h3>
		</template>
		<template slot="body">
			<div class="alert alert-warning d-flex align-items-center">
				<span>{{ $t('Please be aware, that this settings will override all shipping settings on the selected products.') }}</span>
			</div>
			<product-shipping
				@change="onProductPropertiesChange"
			/>
		</template>
		<template slot="footer">
			<button
				type="button"
				class="btn btn-light"
				@click="close">
				{{ $t('Close') }}
			</button>
			<button
				type="button"
				class="btn btn-primary"
				:class="{ 'is-loading': isSubmitting }"
				:disabled="!isFormValid"
				@click="submit">
				{{ $t('Submit') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import products from '@/api/products';
import ProductShipping from '@/components/ProductShipping.vue';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'ProductShippingModal',
	components: {
		Modal,
		ProductShipping,
	},
	props: {
		productIds: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			productProperties: {},
			isSubmitting: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		submit() {
			this.isSubmitting = true;
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Bulk Update Product Shipping',
					text: message,
				});
				this.close();
				this.isSubmitting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Bulk Update Product Shipping',
					text: message,
				});
				this.isSubmitting = false;
			};
			products.bulkUpdate(this.params, callback, errorCallback);
		},
		onProductPropertiesChange(properties) {
			this.productProperties = (properties);
		},
	},
	computed: {
		isFormValid() {
			const valids = [];

			// // validity weight
			// if (this.productProperties && this.productProperties.weight && this.productProperties.weight !== 0) {
			// 	valids[0] = true;
			// } else {
			// 	valids[0] = false;
			// }

			// validity couriers
			if (this.productProperties && this.productProperties.shipping && this.productProperties.shipping.enabled && this.productProperties.shipping.couriers && this.productProperties.shipping.couriers.length !== 0) {
				valids[1] = true;
			} else {
				valids[1] = false;
			}

			// validity services
			if (this.productProperties && this.productProperties.shipping && this.productProperties.shipping.enabled && this.productProperties.shipping.services && this.productProperties.shipping.services.length !== 0) {
				valids[2] = true;
			} else {
				valids[2] = false;
			}

			// validity province
			if (this.productProperties && this.productProperties.shipping && this.productProperties.shipping.enabled && this.productProperties.shipping.origin && this.productProperties.shipping.origin.province_id !== 0) {
				valids[3] = true;
			} else {
				valids[3] = false;
			}

			// validity city
			if (this.productProperties && this.productProperties.shipping && this.productProperties.shipping.enabled && this.productProperties.shipping.origin && this.productProperties.shipping.origin.city_id !== 0) {
				valids[4] = true;
			} else {
				valids[4] = false;
			}

			// validity subdistrict
			if (this.productProperties && this.productProperties.shipping && this.productProperties.shipping.enabled && this.productProperties.shipping.origin && this.productProperties.shipping.origin.subdistrict_id !== 0) {
				valids[5] = true;
			} else {
				valids[5] = false;
			}

			const isValid = valids.filter(value => !value).length === 0;
			return isValid;
		},
		params() {
			const productIds = JSON.stringify(this.productIds);
			const params = Object.assign({}, this.productProperties);
			const shippingJson = JSON.stringify(params.shipping);
			params.shipping = shippingJson;
			params.product_ids = productIds;
			return params;
		},
	},
};
</script>
